module.exports = __webpack_public_path__ + "static/img/zhongzhongka11.fdf9846.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka11.png
// module id = U8Ce
// module chunks = 16